import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./MyLead";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";
import { Tag } from "primereact/tag";
import { LeadHistory } from "../lead/History";
import { StatusUpdate } from "./StatusUpdate";
import useToggle from "../../hooks/useToggle";
import { AddDevice } from "./AddDevice";
import { AddAccessories } from "./AddAccessories";
import { AccessoriesTable } from "./AccessoriesTable";
import { StatusUpdateAcces } from "./StatusUpdateAcce";
import { AccessoriesDetails } from "./AccessoriesDetails";
import { Dialog } from "primereact/dialog";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [filter, setFilter] = useState<IFilter>({});
    // const [selectedRows, setSelectedRows] = useState<ILead[]>([]);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'updatedAt',
        sortOrder: -1
    });
    const [historyModal, setHistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openLeadReqModel, setOpenLeadReqModel] = useState({ singleData: {}, open: false, disabled: false } as any);
    const [openUpdateStatus, setOpenUpdateStatus] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openLeadDeviceAttach, setOpenLeadDeviceAttach] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const [openLeadRequirementManager, setOpenLeadRequirementManager] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openAccessories, setOpenAccessories] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openAccesssoriesTable, setOpenAccesssoriesTable] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openAccessoriesDetails, setOpenAccessoriesDetails] = useState({ singleData: {}, open: false } as IOpenForm);
    const [duplicateModal, setDuplicateModal] = useState({
        open: false,
        leadId: 0,
        data: []
    });
    const hideHistoryDialog = () => {
        setHistoryModal({ singleData: {}, open: false })
        setOpenLeadReqModel({ singleData: {}, open: false })
        setOpenUpdateStatus({ singleData: {}, open: false })
        setOpenLeadDeviceAttach({ singleData: {}, open: false })
    };
    const showHistoryDialog = (rowData: ILead) => {
        setHistoryModal({ singleData: rowData, open: true })
    };

    const openUpdate = (rowData: ILead) => {
        setOpenUpdateStatus({ singleData: rowData, open: true })
    };


    const showDuplicateDialog = async (rowData: any) => {

        const response = await Fetch(
            `Duplicate/GetDuplicateLeadDetails?leadId=${rowData.id}`,
            "GET",
            null,
            null,
            props.toast
        );

        if (response) {
            const data = await response.json();

            setDuplicateModal({
                open: true,
                leadId: rowData.id,
                data: data
            });
        }
    };

    // const showLeadDialog = (rowData: ILead) => {
    //     if (rowData.status_ID === 4) {
    //         setOpenLeadReqModel({ singleData: rowData, open: true, disabled: true })
    //     }
    //     else {

    //         setOpenLeadReqModel({ singleData: rowData, open: true, disabled: false })
    //     }
    // };

    // const showDeviceAttachPlanDialog = (rowData: ILead) => {
    //     setOpenLeadDeviceAttach({ singleData: rowData, open: true })
    // };

    useEffect(() => {
        loadTableData();
    }, [lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const formattedFilter = {
            ...filter,
            fromDate: filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : undefined,
            toDate: filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : undefined,
        };
        const response = await Fetch("leads/mylead", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(formattedFilter)}`, props.toast);
        if (response) {
            const data: { leads: ILead[], count: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.leads, count: data.count, status: data.status, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    // const openEdit = (rowDatauser: ILead) => {
    //     props.setModal({ open: true, singleData: rowDatauser });
    // };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>My Lead</h4>
                </div>
            </div>
            <div className="flex gap-4">
                {props.hasPermission("MyLead", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    // const loadRequiremnets = async (id?: number) => {
    //     const response = await Fetch(`Leadrequirements/getLeadLeadRequirements/${id}`, "GET", null, null, props.toast);
    //     if (response) {
    //         const data: { Leadrequirements: any[], leads: number[] } = await response.json();
    //         setSelectedRows(data.Leadrequirements as ILead[]);
    //         if (data.Leadrequirements.length > 0) {

    //             setOpenLeadReqModel({ singleData: data.Leadrequirements[0], open: true });
    //         } else {
    //             setUpdateStatus(true);
    //         }

    //     }
    // }

    // const loadRequiremnets1 = async (id?: number) => {
    //     const response = await Fetch(`Leadrequirements/getLeadLeadRequirements/${id}`, "GET", null, null, props.toast);
    //     if (response) {
    //         const data: { Leadrequirements: any[], leads: number[] } = await response.json();
    //         setSelectedRows(data.Leadrequirements as ILead[]);
    //         setOpenLeadRequirementManager({ singleData: data.Leadrequirements[0], open: true });
    //     }
    // }

    // const leadFromTemplate = (rowData: ILead) => {
    //     return (<>
    //         {rowData.pocId !== undefined && rowData.pocId > 0 &&
    //             <span>{rowData.pocName}</span>}
    //         {rowData.userId !== undefined && rowData.userId > 0 &&
    //             <span>{rowData.userName}</span>}
    //     </>
    //     );
    // };
    const updatedAtBody = (rowData: ILead) => {
        return (
            <span>{rowData.updatedAt ? format(new Date(rowData.updatedAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }
    const showLeadRequirementManager = (rowData: ILead) => {
        setOpenLeadRequirementManager({ singleData: rowData, open: true });
    };
    const showAccessoriesModal = (rowData: ILead) => {
        setOpenAccessories({ singleData: rowData, open: true });
    };

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div>
                {rowData?.duplicateCount > 0 && (
                    <div className="relative">
                        <Button
                            icon="pi pi-copy"
                            className="p-button-rounded p-button-outlined p-button-warning p-button-sm"
                            tooltip="View Duplicate Leads"
                            onClick={() => showDuplicateDialog(rowData)}
                        />
                        <span
                            style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                                background: "#f59e0b",
                                color: "#fff",
                                borderRadius: "50%",
                                minWidth: "18px",
                                height: "18px",
                                fontSize: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 600
                            }}
                        >
                            {rowData.duplicateCount}
                        </span>
                    </div>
                )}

                <Button icon="pi pi-eye" className="p-button-info p-button-text p-0" onClick={() => setOpenAccessoriesDetails({ singleData: rowData, open: true })} tooltip="View Accessories" />
                <Button icon="pi pi-history" className='p-button-info p-button-text p-0' tooltip="View History" tooltipOptions={{ position: 'top' }} onClick={() => { showHistoryDialog(rowData) }} />
                <Button icon="pi pi-plus" className='p-button-success p-button-text p-0' tooltip="Add Device" tooltipOptions={{ position: 'top' }} onClick={() => { showLeadRequirementManager(rowData); }} />
                <Button icon="pi pi-box" className="p-button-text p-0" style={{ color: '#6c63ff' }} tooltip="Add Accessories" tooltipOptions={{ position: 'top' }} onClick={() => showAccessoriesModal(rowData)} />
            </div>
        );
    };

    const createdAtBody = (rowData: ILead) => {
        return (
            <span>{rowData.createdAt ? format(new Date(rowData.createdAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const addressBody = (rowData: ILead) => {
        return (
            rowData.cityName ?
                <span>{rowData.cityName}, {rowData.stateName}, {rowData.countryName}</span> :
                <span>{rowData.stateName}, {rowData.countryName}</span>
        );
    }

    const statusBody = (rowData: ILead) => {
        return (
            <>
                <Tag severity={rowData.isLeadActive ? 'success' : 'danger'} value={rowData.statusName} rounded onClick={() => { openUpdate(rowData) }}></Tag>
            </>
        );
    }

    const loadAccessoriesBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                {/* <i className={`pi ${rowData.isAccessorriesAdded ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isAccessorriesAdded ? '#4caf50' : '#f44336' }} ></i> */}
                <span style={{
                    color: rowData.isAccessoriesAdded ? '#4caf50' : '#f44336', textDecoration: 'underline',
                    fontSize: '1.1rem', // or any size like '16px', '18px', 'larger'
                    fontWeight: '500'
                }} onClick={() => {
                    rowData.isAccessoriesAdded ?
                        setOpenAccesssoriesTable({ singleData: rowData, open: true }) : setOpenAccesssoriesTable({ singleData: rowData, open: false });
                }}
                >{rowData.accessoriesCount}</span>
            </div >
        );
    }

    const copyToClipboard = async (value: any, type: any) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);

            props.toast.current.show({
                severity: 'success',
                detail: `${type} copied successfully`,
                life: 1500
            });
        } catch (error) {
            console.error("Failed to copy:", error);
        }
    };


    const contactNumberBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Number || '-'}</span>

                {rowData.contact_Person_Number && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact number"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Number,
                                'Contact number'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const emailBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Email || '-'}</span>

                {rowData.contact_Person_Email && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy email"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Email,
                                'Email'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const contactNameBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Name || '-'}</span>

                {rowData.contact_Person_Name && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact name"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Name,
                                'Contact name'
                            )
                        }
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <Filter header={
                <div className="flex align-items-center justify-content-end gap-4">
                    Filter
                    <div className="flex align-items-center justify-content-end gap-2 ml-auto">
                        {/* {tableData.status.map((s) => {
                            return (
                                <Tag key={s.id} onClick={() => setFilter((prev) => ({ ...prev, status_ID: s.id }))} severity={filter.status_ID === s.id ? 'warning' : 'info'} value={`${s.name}: ${s.count}`} rounded></Tag>
                            )
                        })} */}
                    </div>
                </div>} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable className="no-copy-table" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="contact_Person_Name" header="Contact Name" body={contactNameBody} />
                <Column field="contact_Person_Email" header="Email" body={emailBody} />
                <Column field="contact_Person_Number" header="Contact No." body={contactNumberBody} />
                <Column field="address" header="Address" body={addressBody} />
                <Column field="source_Name" header="Source" />
                <Column field="assignedToName" header="Sales Manager" />
                <Column field="statusName" header="Status" sortable body={statusBody} />
                <Column field="" header="Accessories" body={loadAccessoriesBody} />
                <Column field="createdBy" header="CreatedBy" />
                <Column field="createdAt" header="CreatedAt" sortable body={createdAtBody} />
                <Column field="updatedBy" header="UpdatedBy" />
                <Column field="updatedAt" header="UpdatedAt" sortable body={updatedAtBody} />

                <Column field="refferedBy" header="ReferredBy" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            {props.hasPermission("MyLead", "History") && <LeadHistory hasPermission={props.hasPermission} singleData={historyModal.singleData} open={historyModal.open} hideDialog={hideHistoryDialog} toast={props.toast}></LeadHistory>}
            {/* <StatusUpdate reload={reload} reloadData={props.reloadData} hasPermission={props.hasPermission} singleData={openUpdateStatus.singleData} open={openUpdateStatus.open} hideDialog={hideHistoryDialog} toast={props.toast}></StatusUpdate> */}
            <StatusUpdateAcces reload={reload} reloadData={props.reloadData} hasPermission={props.hasPermission} singleData={openUpdateStatus.singleData} open={openUpdateStatus.open} hideDialog={hideHistoryDialog} toast={props.toast}></StatusUpdateAcces>
            <AccessoriesDetails reload={reload} reloadData={props.reloadData} hasPermission={props.hasPermission} singleData={openAccessoriesDetails.singleData} open={openAccessoriesDetails.open} hideDialog={() => setOpenAccessoriesDetails({ singleData: {}, open: false })} toast={props.toast}></AccessoriesDetails>
            <AddDevice hasPermission={props.hasPermission} singleData={openLeadRequirementManager.singleData} open={openLeadRequirementManager.open} hideDialog={() => setOpenLeadRequirementManager({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />
            <AddAccessories hasPermission={props.hasPermission} singleData={openAccessories.singleData} open={openAccessories.open} hideDialog={() => setOpenAccessories({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />
            <AccessoriesTable hasPermission={props.hasPermission} singleData={openAccesssoriesTable.singleData} open={openAccesssoriesTable.open} hideDialog={() => setOpenAccesssoriesTable({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />

            <Dialog
                header="Duplicate Leads"
                visible={duplicateModal.open}
                style={{ width: "70vw" }}
                onHide={() =>
                    setDuplicateModal({
                        open: false,
                        leadId: 0,
                        data: []
                    })
                }
            >
                <DataTable className="no-copy-table"
                    value={duplicateModal.data}
                    responsiveLayout="scroll"
                    stripedRows
                    showGridlines
                >
                    <Column field="id" header="Lead Id" />
                    <Column field="contactName" header="Customer" />
                    <Column field="mobile" header="Mobile" />
                    <Column field="email" header="Email" />
                    <Column field="address" header="Address" body={addressBody} />
                    <Column field="source_Name" header="Source" />
                    <Column field="assignedToName" header="Sales Manager" />
                    <Column field="statusName" header="Status" sortable body={statusBody} />
                    <Column field="createdBy" header="CreatedBy" />

                    <Column
                        field="createdAt"
                        header="Created At"
                        body={(rowData) =>
                            rowData.createdAt
                                ? format(
                                    new Date(rowData.createdAt + "Z"),
                                    "dd/MM/yyyy"
                                )
                                : "-"
                        }
                    />
                </DataTable>
            </Dialog>
            <ConfirmDialog />
        </>
    );
}
